export default __webpack_public_path__ + "static/media/help-icon.4b4be547.svg";